
import { ref, defineComponent, onMounted } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "KTFooter",
  setup() {
    const year = ref("");
    onMounted(() => {
      year.value = new Date().getFullYear().toString();
    });
    return {
      footerWidthFluid,
      year,
    };
  },
});
